import * as XLSX from 'xlsx';

function parseImporto(val) {
  if (val === null || val === undefined || val === '') return null;
  if (typeof val === 'number') return val;
  if (typeof val === 'string') {
    const cleaned = val.replace(/[€\s]/g, '').replace(',', '.');
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }
  return null;
}

export async function parseExcelFile(file) {
  const buffer = await file.arrayBuffer();
  const wb = XLSX.read(buffer, { type: 'array', cellDates: true });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(ws, { defval: '' });

  const valid = [];
  const skipped = [];
  const errors = [];
  const seenIds = new Set();

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    const rowNum = i + 2;
    const rowErrors = [];

    const id = row.ID ?? row.id ?? row.Id ?? row.ID_LAVORAZIONE ?? row.id_lavorazione ?? '';
    if (id === '' || id === undefined || id === null) {
      rowErrors.push('ID mancante');
    } else if (seenIds.has(String(id))) {
      rowErrors.push(`ID ${id} duplicato nel file`);
    }

    const codiceSito = row.CODICE_SITO || row.codice_sito || row.COD_SITO || '';
    if (!codiceSito) rowErrors.push('CODICE_SITO mancante');

    const nomeSito = row.NOME_SITO || row.nome_sito || '';
    if (!nomeSito) rowErrors.push('NOME_SITO mancante');

    const tipologiaLavorazione = row.TIPO_LAVORAZIONE || row.tipo_lavorazione || row.TIPOLOGIA_LAVORAZIONE || row.tipologia_lavorazione || '';

    const ditta = row.DITTA || row.ditta || '';
    if (!ditta) rowErrors.push('DITTA mancante');

    const studioProgettazione = row.STUDIO_PROGETTAZIONE || row.studio_progettazione || row.STUDIO || '';

    const comune = row.COMUNE || row.comune || '';
    if (!comune) rowErrors.push('COMUNE mancante');

    const provincia = row.PROVINCIA || row.provincia || row.PROV || '';
    if (!provincia) rowErrors.push('PROVINCIA mancante');

    if (rowErrors.length > 0) {
      skipped.push({ row: rowNum, errors: rowErrors });
      errors.push(...rowErrors.map((e) => ({ row: rowNum, message: e })));
      continue;
    }

    seenIds.add(String(id));

    valid.push({
      id: typeof id === 'number' ? id : parseInt(id) || id,
      codiceSito: String(codiceSito).trim(),
      nomeSito: String(nomeSito).trim(),
      tipologiaLavorazione: tipologiaLavorazione ? String(tipologiaLavorazione).trim() : null,
      ditta: String(ditta).trim(),
      studioProgettazione: studioProgettazione ? String(studioProgettazione).trim() : null,
      comune: String(comune).trim(),
      provincia: String(provincia).trim().toUpperCase(),
      importo: parseImporto(row.IMPORTO ?? row.importo ?? ''),
    });
  }

  return { valid, skipped, errors };
}
